// Shared utility exports will be added incrementally during migration.

import { API } from "../../cache";

// Downloads an attachment by proxying through the backend (GET
// /attachments/{id}/download) instead of navigating directly to the stored
// file_url — the old SharePoint "organization"-scope sharing link only
// worked for internal Azure AD tenant members, so external users always hit
// a dead end. The backend fetches the bytes itself using its own app-only
// Graph credentials, so tenant membership no longer matters.
export async function downloadAttachment(id) {
  const res = await fetch(`${API}/attachments/${id}/download`, { credentials: "include" });
  if (!res.ok) throw new Error("Failed to download attachment");
  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  window.open(url, "_blank");
  // Revoke after a short delay so the new tab has time to load the object URL.
  setTimeout(() => URL.revokeObjectURL(url), 30_000);
}
